import { ComparisonDateUtils } from './comparison';
import { PeriodDateUtils } from './period';
import { SerializationDateUtils } from './serialization';
import { TimeDateUtils } from './time';
import { TransformationsDateUtils } from './transformation';
import { DurationDateUtils } from './duration';

export class DateUtils {
  public static comparison = ComparisonDateUtils;
  public static period = PeriodDateUtils;
  public static duration = DurationDateUtils;
  public static serialization = SerializationDateUtils;
  public static time = TimeDateUtils;
  public static transformations = TransformationsDateUtils;
}
